module.exports = __webpack_public_path__ + "static/media/maze-music.929c89c6.mp3";